import { Controller } from "@hotwired/stimulus"
import { loadStripe } from "@stripe/stripe-js"

export default class extends Controller {
  static values = {
    stripePublicKey: String,
    setupIntentsUrl: String,
    completionUrl: String
  }

  async connect() {
    // https://docs.stripe.com/js/initializing
    // https://github.com/stripe/stripe-js

    const stripe = await loadStripe(this.stripePublicKeyValue)

    const metaCsrfToken = document.querySelector('meta[name="csrf-token"]')
    const csrfToken = metaCsrfToken ? metaCsrfToken.content : ''
    fetch(this.setupIntentsUrlValue, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "X-CSRF-Token": csrfToken
      }
    })
    .then(r => r.json())
    .then(({ client_secret }) => {
      const clientSecret = client_secret

      const elements = stripe.elements({
        clientSecret: clientSecret,
        locale: 'de',
        currency: 'eur'
      })

      const expressCheckoutElement = elements.create("expressCheckout", {
        business: {
          name: "CleanCar AG"
        },
        layout: {
          maxColumns: 1,
          maxRows: 0,
          overflow: 'never'
        }
      })
      expressCheckoutElement.mount("#stripe-element")

      //expressCheckoutElement.on('click', async (event) => {
      //  const { resolve, expressPaymentType } = event
      //
      //  if (expressPaymentType === 'paypal') {
      //    resolve({
      //      return_url: this.completionUrlValue,
      //    })
      //  } else {
      //    resolve()
      //  }
      //})

      expressCheckoutElement.on('confirm', async (event) => {
        const { expressPaymentType } = event
        console.log('Payment method selected:', expressPaymentType)

        const { error, setupIntent } = await stripe.confirmSetup({
          elements,
          confirmParams: {
            return_url: this.completionUrlValue,
          }
        });

        if (error) {
          console.error('Setup failed:', error);
        } else if (expressPaymentType === 'paypal') {
          // For PayPal, the page will automatically redirect
          console.log('Redirecting to PayPal...');
        } else {
          // For wallet methods like Apple Pay and Google Pay that don't redirect
          console.log('Setup completed successfully');
          //document.getElementById('express-checkout-element').style.display = 'none';
          //document.getElementById('setup-message').style.display = 'block';
        }

        //const { error } = await stripe.confirmSetup({
        //  elements,
        //  confirmParams: {
        //    return_url: this.completionUrlValue,
        //  }
        //})
        //
        //if (error) {
        //  console.error('Setup failed:', error)
        //} else if (expressPaymentType !== 'paypal') {
        //  document.getElementById('stripe-element').style.display = 'none'
        //
        //  const url = new URL(this.completionUrlValue)
        //  //url.searchParams.append("setup_intent_id", setupIntent.id)
        //  //window.location.href = url.toString()
        //}
      })

      // // For ApplePay, the 'confirm' event is called as part of the payment flow
      // // and receives a new setup intent id. This is why we need to append the
      // // new id to the url here.
      // //
      // // For PayPal, the 'confirm' event is never called and the setup intent id
      // // stays the same.
      // //
      // expressCheckoutElement.on('confirm', async (event) => {
      //   const { setupIntent, error } = await stripe.confirmSetup({
      //     elements,
      //     clientSecret: this.clientSecretValue,
      //     confirmParams: {
      //       return_url: this.completionUrlValue
      //     },
      //     redirect: "if_required"
      //   })
      //
      //   if (error) {
      //     console.error("Stripe error", error)
      //     alert(error.message)
      //     return
      //   }
      //
      //   const url = new URL(this.completionUrlValue)
      //   url.searchParams.append("setup_intent_id", setupIntent.id)
      //   window.location.href = url.toString()
      // })
    })
  }
}
